export default __webpack_public_path__ + "static/feniks_okladka-4d76d8aa0a68a7e87373c6e71e15a15d.jpg";